import { UiNavSection } from '../../models/ui-sidebar.model';
import { UiTableColumn, UiTableFilter } from '../../models/ui-table.model';

export interface MockRequisition {
  id: number;
  slNo: number;
  reqNo: string;
  type: string;
  branch: string;
  store: string;
  section: string;
  date: string;
  remark: string;
  status: string;
}

export const SHOWCASE_MENU_SECTIONS: UiNavSection[] = [
  {
    title: 'Masters',
    items: [
      { path: 'vendor-master', label: 'Vendor Master', icon: 'person' },
      { path: 'vendor-branch-master', label: 'Vendor Branch Master', icon: 'person' },
      { path: 'customer-master', label: 'Customer Master', icon: 'person' },
      { path: 'customer-branch-master', label: 'Customer Branch Master', icon: 'person' },
      { path: 'contact-person-master', label: 'Contact Person Master', icon: 'person' },
    ],
  },
  {
    title: 'Procurement',
    items: [
      { path: 'requisition-master', label: 'Purchase Requisition', icon: 'assignment' },
      { path: 'request-for-quotation-master', label: 'RFQ', icon: 'request_quote' },
      { path: 'quotation-receive', label: 'Quotation Receive', icon: 'library_books' },
      { path: 'quotation-comparision', label: 'Quotation Comparison', icon: 'compare_arrows' },
      { path: 'purchase-order', label: 'Purchase Order', icon: 'shopping_cart_checkout' },
      { path: 'grn-master', label: 'GSRN', icon: 'local_shipping' },
      { path: 'quality-check', label: 'Quality Check', icon: 'verified' },
    ],
  },
  {
    title: 'Sales & Invoicing',
    items: [
      { path: 'voucher-posting-supplysync', label: 'Posted PI / SI', icon: 'receipt_long' },
      { path: 'voucher-posting-create-supplysync', label: 'Create PI / SI', icon: 'receipt_long' },
      { path: 'sales-order', label: 'Sales Order', icon: 'shopping_cart_checkout' },
      { path: 'gsn-master', label: 'GSSN', icon: 'local_shipping' },
    ],
  },
];

export const SHOWCASE_TABLE_COLUMNS: UiTableColumn[] = [
  { key: 'slNo', label: 'Sl No', width: '60px' },
  { key: 'reqNo', label: 'Requisition No', type: 'link', sortable: true },
  { key: 'type', label: 'Type', type: 'badge' },
  { key: 'branch', label: 'Branch' },
  { key: 'store', label: 'Store' },
  { key: 'section', label: 'Section' },
  { key: 'date', label: 'Date', type: 'date', sortable: true },
  { key: 'remark', label: 'Remark' },
  { key: 'status', label: 'Status', type: 'badge' },
  { key: 'actions', label: 'Action', type: 'actions', width: '120px' },
];

export const SHOWCASE_MOCK_DATA: MockRequisition[] = [
  { id: 1, slNo: 1, reqNo: 'REQ_S_69', type: 'Services', branch: 'RD Steel', store: '—', section: 'MM', date: '2025-11-17', remark: 'test', status: 'Approved' },
  { id: 2, slNo: 2, reqNo: 'REQ_S_68', type: 'Services', branch: 'RD Steel', store: '—', section: 'MM', date: '2025-11-17', remark: 'test', status: 'Approved' },
  { id: 3, slNo: 3, reqNo: 'REQ_S_67', type: 'Services', branch: 'RD Steel', store: '—', section: 'MM', date: '2025-11-17', remark: 'test', status: 'Approved' },
  { id: 4, slNo: 4, reqNo: 'REQ_S_66', type: 'Services', branch: 'RD Steel', store: '—', section: 'MM', date: '2025-11-17', remark: 'test', status: 'Approved' },
  { id: 5, slNo: 5, reqNo: 'REQ_S_65', type: 'Services', branch: 'RD Steel', store: '—', section: 'MM', date: '2025-11-17', remark: 'test', status: 'Approved' },
  { id: 6, slNo: 6, reqNo: 'REQ_G_12', type: 'Goods', branch: 'KD Steel', store: 'Main Store', section: 'Utilities', date: '2025-11-16', remark: 'urgent', status: 'Pending' },
  { id: 7, slNo: 7, reqNo: 'REQ_G_11', type: 'Goods', branch: 'KD Steel', store: '—', section: 'Utilities', date: '2025-11-15', remark: 'spare parts', status: 'Pending' },
  { id: 8, slNo: 8, reqNo: 'REQ_FA_3', type: 'Fixed Asset', branch: 'RD Steel', store: '—', section: 'MM', date: '2025-11-14', remark: 'machinery', status: 'Rejected' },
];

export function createShowcaseFilters(): UiTableFilter[] {
  return [
    {
      key: 'status',
      label: 'All statuses',
      value: 'all',
      showIcon: true,
      options: [
        { label: 'All statuses', value: 'all' },
        { label: 'Approved', value: 'Approved' },
        { label: 'Pending', value: 'Pending' },
        { label: 'Rejected', value: 'Rejected' },
      ],
    },
    {
      key: 'type',
      label: 'All types',
      value: 'all',
      showIcon: false,
      options: [
        { label: 'All types', value: 'all' },
        { label: 'Services', value: 'Services' },
        { label: 'Goods', value: 'Goods' },
        { label: 'Fixed Asset', value: 'Fixed Asset' },
      ],
    },
  ];
}

export function toTableRows(data: MockRequisition[]): Record<string, unknown>[] {
  return data.map(item => ({
    ...item,
    actions: [
      { type: 'view', visible: true },
      { type: 'edit', visible: true },
      { type: 'more', visible: true },
    ],
  }));
}
